import { StyleSheet, Platform } from 'react-native';
import type { Theme } from '../../../theme/getTheme';
import { PALETTE } from './CoinStoreModal.constants';

export const purchaseProcessingOverlayStyles = (theme: Theme) => StyleSheet.create({
  backdrop: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(8,4,16,0.72)',
    zIndex: 200,
  },
  card: {
    alignItems: 'center',
    gap: 14,
    paddingVertical: 26,
    paddingHorizontal: 30,
    borderRadius: 18,
    backgroundColor: PALETTE.surface,
    borderWidth: 2,
    borderColor: `${theme.accent}59`,
    maxWidth: 300,
    ...(Platform.OS === 'web'
      ? { boxShadow: '0 16px 40px rgba(0,0,0,0.6)' }
      : { shadowColor: '#000', shadowOffset: { width: 0, height: 10 }, shadowOpacity: 0.5, shadowRadius: 18, elevation: 16 }),
  },
  message: {
    fontSize: 15,
    fontWeight: '800',
    color: theme.white,
    textAlign: 'center',
  },
  dismissBtn: {
    marginTop: 4,
    paddingVertical: 8,
    paddingHorizontal: 18,
    borderRadius: 999,
    borderWidth: 1.5,
    borderColor: `${theme.white}33`,
  },
  dismissBtnPressed: { opacity: 0.7 },
  dismissText: {
    fontSize: 13,
    fontWeight: '700',
    color: theme.gray[300],
  },
});
